import React from 'react';
import { ViewModule, CropDin } from '@mui/icons-material';
import Toggle from '../utils/Toggle';
import { DENSITY_DETAILED, DENSITY_COMPACT } from '../../core/searchConfig';

const TXT_DENSITY = { fr: 'Mode d\'affichage', en: 'Display mode', de: 'Anzeigemodus', es: 'Modo de visualización', pt: 'Modo de exibição' };
const TXT_DENSITY_DETAILED = { fr: 'Vue détaillée', en: 'Detailed view', de: 'Detailansicht', es: 'Vista detallada', pt: 'Vista detalhada' };
const TXT_DENSITY_COMPACT = { fr: 'Vue compacte', en: 'Compact view', de: 'Kompakte Ansicht', es: 'Vista compacta', pt: 'Vista compacta' };

/**
 * Detailed cards or compact tiles, for the end of the results-count row — a
 * display preference sitting with the thing it changes, not with the filters.
 */
const DensityToggle = ({ lang = 'fr', density = DENSITY_DETAILED, onChange }) => (
    <Toggle
        variant="pill"
        className="search-density-toggle"
        ariaLabel={TXT_DENSITY[lang] || TXT_DENSITY.en}
        value={density}
        onChange={onChange}
        items={[
            {
                value: DENSITY_DETAILED,
                icon: <CropDin fontSize="small" />,
                tooltip: TXT_DENSITY_DETAILED[lang] || TXT_DENSITY_DETAILED.en,
                ariaLabel: TXT_DENSITY_DETAILED[lang] || TXT_DENSITY_DETAILED.en,
            },
            {
                value: DENSITY_COMPACT,
                icon: <ViewModule fontSize="small" />,
                tooltip: TXT_DENSITY_COMPACT[lang] || TXT_DENSITY_COMPACT.en,
                ariaLabel: TXT_DENSITY_COMPACT[lang] || TXT_DENSITY_COMPACT.en,
            },
        ]}
    />
);

export default DensityToggle;
